/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StageEquipmentRequest } from '../../models/stage-equipment-request';
import { StageEquipmentResponse } from '../../models/stage-equipment-response';

export interface AdminServiceStageEquipment$Params {
      body: StageEquipmentRequest
}

export function adminServiceStageEquipment(http: HttpClient, rootUrl: string, params: AdminServiceStageEquipment$Params, context?: HttpContext): Observable<StrictHttpResponse<StageEquipmentResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceStageEquipment.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StageEquipmentResponse>;
    })
  );
}

adminServiceStageEquipment.PATH = '/api/v3/gateway/admin/stage/equipment';
